import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Observable, lastValueFrom } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { FacilityService } from 'src/app/services/facility.service';
import { Location } from '@angular/common';
import { WoundService } from 'src/app/services/wound.service';
import { MatTableDataSource } from '@angular/material/table';
import { HttpResponse } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from 'src/app/services/auth.service';
import ExcelJS from 'exceljs';
import { flatten } from 'flat';
@Component({
  selector: 'app-dns-report',
  templateUrl: './dns-report.component.html',
  styleUrls: ['./dns-report.component.css']
})
export class DnsReportComponent implements OnInit {

  currentDate = moment(new Date());
  minDate = moment(new Date()).subtract(6, 'days');
  loaderId = 'app-dns-report';
  filter: any = {
    updatedAt: {
      startDate: moment().subtract(6, 'days'),
      endDate: moment()
    },
    facilityId: null,
    companyId: null,
    state: 'all'
  };
  preDateRanges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 1 Week': [moment().subtract(6, 'days'), moment()],
    // 'Last 2 Week': [moment().subtract(13, 'days'), moment()],
    // 'Last 3 Week': [moment().subtract(20, 'days'), moment()],
    // 'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    // 'This Month': [moment().startOf('month'), moment().endOf('month')],
    // 'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  };
  filteredFacilities: Observable<string[]>;
  displayedColumns: string[] = [
    'name', 'wound_recognition_date', 'wound_recognition_date_type', 'woundNo', 'body_part', 'etiolgy', 'stage', 'length', 'width', 'depth', 'state', 'diffInWeek', 'area_change', 'icds'];
  facilityControl = new FormControl();
  facilities: Array<any> = [];
  dnsReport: any = [];
  dataSource: any = new MatTableDataSource([]);
  poaCount: number = 0;
  facilityAcquiredCount: number = 0;
  openWoundsCount: number = 0;
  inRemissionWoundsCount: number = 0;
  pagination = {
    pageNo: 1,
    hasNextPage: false,
    hasPrevPage: false,
    totalRecords: 0,
    // totalPages: 0,
    // currentRecords: 0
    PAGE_LIMIT: 50,
    skip: 0
  };
  companySide: boolean = false;
  currentUser: any;
  user_dashboard: Boolean = false;
  nursingSide: boolean;
  constructor(
    private _toastr: ToastrService,
    private _facilityService: FacilityService,
    private _route: ActivatedRoute,
    private _location: Location,
    private _wound: WoundService,
    private loader: NgxUiLoaderService,
    private _authService: AuthService
  ) {
    this.currentUser = this._authService.currentUser;
    this.filter.companyId = this._route.parent.snapshot.params.id;
    this._route.queryParams.subscribe((params: any) => {
      if (params) {
        console.log("params", params);
      }
    });
    if (this._route.parent.snapshot.params.id) {
      this.companySide = true;
    } else {
      this.filter.companyId = this.currentUser.company_id;
    }
    if (window.location.pathname.includes('dashboard')) {
      this.user_dashboard = true;
    }
    if (window.location.pathname.includes('nursing')) {
      this.nursingSide = true;
    }
  }

  async ngOnInit(): Promise<void> {
    this.loader.startLoader(this.loaderId);
    await this.initFacilities();
    this.selectDefaultFacility();
    this.initEnhancedDnsReport();
    this.filteredFacilities = this.facilityControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this.filterFacilities(value)));
    this.loader.stopLoader(this.loaderId);
  }
  private filterFacilities(value: string): string[] {
    if (value) {
      const filterValue = value.toLowerCase();
      return this.facilities.filter(option => option.title.toLowerCase().indexOf(filterValue) > -1);
    }
    else {
      return this.facilities;
    }
  }
  selectDefaultFacility() {
    if (this.facilities.length > 0) {
      this.filter.facilityId = this.facilities[0]._id;
    }
    this.facilityControl.setValue(this.facilities[0].title);
  }
  initDnsReport() {
    this.loader.startLoader(this.loaderId);
    this.filter.pageNo = this.pagination.pageNo;
    this._wound.getDnsReport(this.filter).subscribe((response: any) => {
      if (response.status == 200) {
        this.dnsReport = response.data.dnsReport;
        this.pagination.totalRecords = response.data.totalRecords;
        this.handlePagination();
        [this.inRemissionWoundsCount, this.openWoundsCount,
        this.poaCount, this.facilityAcquiredCount] = [0, 0, 0, 0];
        if (this.dnsReport.length > 0) {
          for (const report of this.dnsReport) {
            report.createdAt = moment(report.createdAt).format("MMM DD, YYYY");
            if (report.wound_recognition_date_type === "yes") {
              this.poaCount++;
            }
            else {
              this.facilityAcquiredCount++;
            }
            if (report.state === "active") {
              this.openWoundsCount++;
            }
            else if (report.state === "remission") {
              this.inRemissionWoundsCount++;
            }
          }
        }
        this.dataSource.data = this.dnsReport;
        this.loader.stopLoader(this.loaderId);
      }
      else {
        this.loader.stopLoader(this.loaderId);

      }
    }, err => {
      this.loader.stopLoader(this.loaderId);
      this._toastr.error(err, "ERROR");
    }
    );
  }
  async initEnhancedDnsReport(shouldDownload: boolean = false): Promise<void> {
    this.loader.startLoader(this.loaderId);
    try {
      if (shouldDownload) {
        this.filter.shouldDownload = true;
      }
      else {
        this.filter.pageNo = this.pagination.pageNo;
      }
      const { status, data } = await lastValueFrom(this._wound.getEnhancedDnsReport(this.filter)) as any;
      if (status === 200) {
        const dnsReport = this.discardInitialIfRevisionExists(data.dnsReport);
        if (shouldDownload) {
          this.filter.shouldDownload = false;
          await this.downloadDnsReportAsXLSX(dnsReport);
          return;
        }
        this.dnsReport = dnsReport;
        this.pagination.totalRecords = data.totalRecords;
        this.handlePagination();
        [this.inRemissionWoundsCount, this.openWoundsCount, this.poaCount, this.facilityAcquiredCount] = [0, 0, 0, 0];
        for (const report of this.dnsReport) {
          report.createdAt = moment(report.createdAt).format("MMM DD, YYYY");
          if (report.wound_recognition_date_type === "yes") {
            this.poaCount++;
          }
          else if (report.wound_recognition_date_type === "no") {
            this.facilityAcquiredCount++;
          }
          if (report.state === "active") {
            this.openWoundsCount++;
          }
          else if (report.state === "remission") {
            this.inRemissionWoundsCount++;
          }
        }
        this.dataSource.data = this.dnsReport;
      }
      else {
        this._toastr.error("Something Went Wrong", "ERROR");
      }
    } catch (err) {
      this._toastr.error(err, "ERROR");
    }
    finally {
      this.loader.stopLoader(this.loaderId);
    }
  }

  discardInitialIfRevisionExists(wounds): Array<any> {
    if (wounds.length > 0) {
      const referencedParentIds = new Set(
        wounds.map(wound => wound.parent_wound).filter(id => id !== null)
      );
      return wounds.filter(wound => !(wound.parent_wound === null && referencedParentIds.has(wound._id)));
    }
    return wounds;
  }

  handlePagination(): void {
    this.pagination.skip = (this.pagination.pageNo - 1) * this.pagination.PAGE_LIMIT;
    if (this.pagination.skip + this.dnsReport.length < this.pagination.totalRecords) {
      this.pagination.hasNextPage = true;
    }
    else {
      this.pagination.hasNextPage = false;
    }
    if (this.pagination.skip > 0) {
      this.pagination.hasPrevPage = true;
    }
    else {
      this.pagination.hasPrevPage = false;
    }
  }

  async initFacilities() {
    const filter = {
      company_id: this.filter.companyId,
      is_active: true
    };
    const projection = {
      title: 1
    };
    const facilitiesResponse: any = await this._facilityService.getAllFacilities(filter, projection).toPromise();
    if (facilitiesResponse.status == 200) {
      this.facilities = facilitiesResponse.data.array;
    }
  }
  onSelectFacility($event, facility) {
    if ($event.isUserInput) {
      this.filter.facilityId = facility._id;
    }
  }
  changeUpdatedAt(event) {
    if (event.startDate && event.endDate) {
      this.filter.updatedAt = {
        startDate: null,
        endDate: null
      };
      const startDate = moment(event.startDate);
      const endDate = moment(event.endDate);
      const noOfDays = endDate.diff(startDate, 'days');
      if (noOfDays > 6) {
        this.filter.updatedAt = {};
        this.filter.updatedAt.startDate = moment(event.startDate);
        this.filter.updatedAt.endDate = moment(this.filter.updatedAt.startDate).add(6, "days").endOf('day');
        this._toastr.error('Can not select more than 7 days', 'Date Error');
      }
      else {
        this.filter.updatedAt.startDate = event.startDate;
        this.filter.updatedAt.endDate = event.endDate;
      }
    }
  }

  goBack() {
    this._location.back();
  }
  async handleApplyFilter() {
    this.pagination = {
      pageNo: 1,
      hasNextPage: false,
      hasPrevPage: false,
      totalRecords: 0,
      PAGE_LIMIT: 50,
      skip: 0
    };
    await this.initEnhancedDnsReport();
  }

  calculateArea(ele) {
    if (ele.earliestRevisionArea && ele.recentWound) {
      return 100 - ((ele.recentWound.recentRevisionArea / ele.earliestRevisionArea) / 100)
    }
    return ele.earliestRevisionArea;
  }
  onStateChange(value) {
    this.filter.state = value;
  }
  async resetFilter() {
    delete this.filter.updatedAt;
    const defaultDate = {
      startDate: moment().subtract(6, 'days'),
      endDate: moment()
    };
    this.filter.updatedAt = defaultDate;
    this.filter.state = "all";
    this.selectDefaultFacility();
    await this.initEnhancedDnsReport();
  }
  exportDnsReportAsXLSX() {
    delete this.filter.pageNo;
    const infoToastr = this._toastr.info('Exporting as XLSX...', 'Please wait', { disableTimeOut: true });
    this._wound.exportDnsReportAsXLSX(this.filter).subscribe((response: any) => {
      if (response instanceof HttpResponse) {
        const url = window.URL.createObjectURL(response.body);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = `Dns Report`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
        this._toastr.clear(infoToastr.toastId);
      }
    }, error => {
      console.log("err", error);
      this._toastr.clear(infoToastr.toastId);
    });
  }

  async downloadDnsReportAsXLSX(wounds): Promise<void> {
    const reportTitle = "DNS Report";
    const columnsData = [
      { header: "Name", key: "patient_id.full_name", width: 20 },
      { header: "Date Acquired", key: "wound_recognition_date", width: 15 },
      { header: "POA", key: "wound_recognition_date_type", width: 10 },
      { header: "#", key: "woundNo", width: 10 },
      { header: "Location", key: "body_part", width: 10 },
      { header: "Etiology", key: "etiolgy", width: 10 },
      { header: "Severity", key: "stage", width: 15 },
      { header: "L", key: "length", width: 10 },
      { header: "W", key: "width", width: 10 },
      { header: "D", key: "depth", width: 10 },
      { header: "Status", key: "state", width: 10 },
      { header: "Weeks", key: "diff_in_weeks", width: 10 },
      { header: "Area Change (%)", key: "area_change", width: 20 },
      { header: "DX10 Codes", key: "icds", width: 20 }
    ];
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(reportTitle);
    worksheet.columns = columnsData;

    worksheet.insertRow(0, []);
    const cell = worksheet.getCell("A1");
    cell.value = this.filter.updatedAt.startDate.format("MMM DD, YYYY") + " - " + this.filter.updatedAt.endDate.format("MMM DD, YYYY");
    cell.font = { bold: true };
    const column = worksheet.getColumn(1);
    column.width = 25;

    for (const wound of wounds) {
      worksheet.addRow(flatten(wound));
    }
    worksheet.getRow(2).eachCell((cell) => {
      cell.font = { bold: true };
    });
    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { wrapText: true };
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${reportTitle}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }

  async goToPreviousPage(): Promise<void> {
    this.pagination.pageNo--;
    await this.initEnhancedDnsReport();
  }
  async goToNextPage(): Promise<void> {
    this.pagination.pageNo++;
    await this.initEnhancedDnsReport();
  }
}

